/**
 * Permission constants for authorization checks.
 * Use these constants instead of hardcoded strings to ensure type safety and consistency.
 */

/**
 * Platform-level permissions
 */
export const PLATFORM_PERMISSIONS = {
  ADMINISTER: "administer",
  ACCESS: "access"
} as const

/**
 * Resource-level abilities for customers
 */
export const RESOURCE_ABILITIES = {
  VIEW_MODULES: "view_modules",
  VIEW_DEPLOYMENTS: "view_deployments",
  CREATE_DEPLOYMENTS: "create_deployments",
  EDIT_DEPLOYMENTS: "edit_deployments",
  EDIT: "edit",
  MANAGE_MEMBERS: "manage_members"
} as const
